import { useMemo, useState } from "react";

import { classFor, iconUrls } from "../data/classes";

interface Props {
  name?: string;
  type?: string | null;
  icon?: string | null;
  /** When true, renders just the icon + colored swatch with no name. */
  compact?: boolean;
}

export default function PlayerCell({ name, type, icon, compact }: Props) {
  const cls = classFor(type ?? undefined);

  const candidates = useMemo(
    () => iconUrls(icon, type ?? undefined),
    [icon, type],
  );
  const [idx, setIdx] = useState(0);
  const url = idx < candidates.length ? candidates[idx] : null;

  return (
    <div className="flex items-center gap-2 min-w-0">
      {url ? (
        <img
          // Re-mount when we step to the next candidate so the browser
          // actually attempts the new URL even after a 403.
          key={url}
          src={url}
          alt={cls.name}
          loading="lazy"
          onError={() => setIdx((i) => i + 1)}
          className="h-6 w-6 rounded border border-black/40 shadow-sm flex-shrink-0 object-cover"
          style={{ outline: `1px solid ${cls.color}55` }}
        />
      ) : (
        <span
          aria-label={cls.name}
          title={cls.name}
          className="h-6 w-6 rounded border border-black/40 flex-shrink-0 grid place-items-center text-[9px] font-bold"
          style={{ background: cls.color, color: "#0e1116" }}
        >
          {cls.shortName}
        </span>
      )}
      {!compact && (
        <span
          className="truncate font-medium"
          style={{ color: cls.color }}
          title={name}
        >
          {name ?? "—"}
        </span>
      )}
    </div>
  );
}
